import { apiServices } from "../../../../core/utilities/ApiServices";
import { SubscriptionPlan } from "../../domain/entities/SubscriptionPlan";
import { UserSubscription } from "../../domain/entities/UserSubscription";
export interface SubscriptionsDataSource {
	getSubscriptionAll(): Promise<SubscriptionPlan[]>;
	createSubscriptionWithPaypal(subscription_id: string): Promise<string>;
	getSubscriptionByUser(): Promise<UserSubscription>;
	cancelSubscriptionWithPaypal(): Promise<void>;
}

export class SubscriptionsDataSourceImpl implements SubscriptionsDataSource {
	async getSubscriptionAll(): Promise<SubscriptionPlan[]> {
		const response = await apiServices.get(`/subscription/all`, { timeout: 30000 });
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error();
		}
	}

	async createSubscriptionWithPaypal(
		subscription_id: string
	): Promise<string> {
		const response = await apiServices.post(
			`/subscription/create-suscription-paypal`,
			{ suscription_id: subscription_id },
			{ timeout: 30000 }
		);
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error();
		}
	}

	async getSubscriptionByUser(): Promise<UserSubscription> {
		const response = await apiServices.get(`/subscription/by-user`, { timeout: 30000 });
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error();
		}
	}

	async cancelSubscriptionWithPaypal(): Promise<void> {
		const response = await apiServices.put(
			`/subscription/cancel-suscription-paypal`, undefined,
			{ timeout: 30000 }
		);
		if (response.status !== 200) {
			throw new Error();
		}
	}
}
